import { Fragment, ReactNode, useState } from "react";
import { IMenuTypes, isIMenuButton, isIMenuLink } from "@/utils/models/core";

import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import clsx, { ClassValue } from "clsx";

import { Link } from "react-router-dom";
import { Placement } from "@popperjs/core/index";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { Button } from "@/components/ui/button";

interface IMenuAction {
	menuButton: string | ReactNode;
	menu: IMenuTypes[];
	placement?: Placement;
	classNameMain?: ClassValue;
	classNameMenuButton?: ClassValue;
}

const MenuAction = ({ menuButton, menu, classNameMenuButton }: IMenuAction) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	return (
		<DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
			<DropdownMenuTrigger
				className={clsx(
					"h-full cursor-pointer flex items-center space-x-1 bg-transparent ",
					classNameMenuButton
				)}
				style={{ outline: "none" }}>
				{menuButton}
				<ChevronDownIcon className="text-white w-5 h-5" />
			</DropdownMenuTrigger>
			<DropdownMenuContent className="w-60 mt-5">
				{menu.map((item: IMenuTypes, index) => {
					return (
						<Fragment key={index}>
							{isIMenuLink(item) && (
								<div>
									<DropdownMenuItem onClick={() => setIsOpen(false)}>
										<Link
											to={item?.to}
											className={clsx(
												item.className,
												"text-sm",
												"group flex items-center w-full px-2 py-2 text-opus-gray-400 hover:text-opus-blue-100"
											)}>
											{item.icon}
											{item.label}
										</Link>
									</DropdownMenuItem>
									<DropdownMenuSeparator />
								</div>
							)}
							{isIMenuButton(item) && (
								<DropdownMenuItem onClick={() => setIsOpen(false)}>
									<Button
										onClick={item.onClick}
										variant="default"
										className={clsx(
											item.className,
											"bg-transparent hover:bg-transparent text-left justify-start text-opus-gray-400 hover:text-opus-blue-100 hover:no-underline p-2 space-y-2 w-full"
										)}>
										{item.icon}

										{item.label}
									</Button>
								</DropdownMenuItem>
							)}
						</Fragment>
					);
				})}
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export default MenuAction;
